(function() {
  var MATOMO_URL = 'https://stats.deathrag.de/';
  var SITE_ID = '1';

  function startMatomo() {
    if (window._paq && window._paq.__matomoLoaded) return;
    var _paq = window._paq = window._paq || [];
    _paq.__matomoLoaded = true;
    _paq.push(['setTrackerUrl', MATOMO_URL + 'matomo.php']);
    _paq.push(['setSiteId', SITE_ID]);
    _paq.push(['enableLinkTracking']);
    _paq.push(['trackPageView']);

    var d = document, g = d.createElement('script'), s = d.getElementsByTagName('script')[0];
    g.async = true;
    g.src = MATOMO_URL + 'matomo.js';
    s.parentNode.insertBefore(g, s);
  }

  function tryShopifyPrivacyAPI() {
    if (typeof Shopify !== 'undefined' && Shopify.customerPrivacy) {
      var cp = Shopify.customerPrivacy;
      if (cp.analyticsProcessingAllowed && cp.analyticsProcessingAllowed()) {
        startMatomo();
        return true;
      }
      document.addEventListener('visitorConsentCollected', function() {
        if (cp.analyticsProcessingAllowed()) startMatomo();
      });
      return true;
    }
    return false;
  }

  function tryLoadFeatures() {
    if (typeof Shopify !== 'undefined' && Shopify.loadFeatures) {
      Shopify.loadFeatures([
        { name: 'consent-tracking-api', version: '0.1' }
      ], function(error) {
        if (error) return;
        if (!tryShopifyPrivacyAPI()) {
          document.addEventListener('visitorConsentCollected', function() {
            if (Shopify.customerPrivacy && Shopify.customerPrivacy.analyticsProcessingAllowed()) {
              startMatomo();
            }
          });
        }
      });
      return true;
    }
    return false;
  }

  function hasMatomoCookies() {
    return document.cookie.indexOf('_pk_id') !== -1;
  }

  if (hasMatomoCookies()) {
    startMatomo();
  } else if (!tryLoadFeatures()) {
    document.addEventListener('DOMContentLoaded', function() {
      if (!tryLoadFeatures() && !tryShopifyPrivacyAPI()) {
        document.addEventListener('visitorConsentCollected', function() {
          startMatomo();
        });
      }
    });
  }
})();
